import {Component, ElementRef, Renderer2, ViewEncapsulation} from '@angular/core';
import {BaseModalClass} from "../../shared/modal/base-modal";

@Component({
    selector: 'email-address-modal',
    templateUrl: './email-address-modal.component.html',
    styleUrls: ['./email-address-modal.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class EmailAddressModalComponent extends BaseModalClass {

    /**
     * Email address model.
     */
    public emailAddress: string;

    /**
     * EmailAddressModalComponent Constructor.
     */
    constructor(protected el: ElementRef, protected renderer: Renderer2) {
        super(el, renderer);
    }

    /**
     * Return email user has entered to caller.
     */
    public confirm() {
        super.done(this.emailAddress);
    }

}



// WEBPACK FOOTER //
// E:/wamp64/www/helpdesk/client/src/app/user/email-address-modal/email-address-modal.component.ts